<app-loader [isLoading]="isLoading"></app-loader>
<div class="print-monitor-section">
  <div class="print-monitor-header">
    <div>
      @if(!mobileDevice){
      <span class="print-monitor-text">Print and monitor &nbsp; &nbsp;</span>}
      <span class="refreshed-date-text">{{
        lastRefreshedDate
        ? "(Last Refreshed Date- " +
        lastRefreshedDate +
        "
        )"
        : ""
        }}</span>
    </div>
    @if(!mobileDevice && showReportType==='PINCODES' && !mobileDevice){

    <button class="wishlist-btn dp-primary-btn" (click)="openWishlistDialog(memberData, 'centralizedPm')">
      <span class="me-2">View Wishlists</span>
      <div class="img-div" style="background: var(--heart-icon);"></div>
    </button>

    }
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="bredcrumb">
        <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index; let last = last">
          <span (click)="!last && onBreadcrumbClick(i)" [ngClass]="
              !last ? 'brancd-prime me-2 cursor-pointer' : 'text-disable me-2'
            ">{{ breadcrumb }}</span>
          <img *ngIf="!last" src="../../assets/images/chevron.svg" class="me-2" />
        </ng-container>
      </div>
    </div>
  </div>
  <div class="print-monitor-button-container d-flex justify-content-between">
    <!-- <button class="filter-button" [class.inactive]="filterValue.value!==3"
    (click)="openFilterDialog()">remove after id is activated
      <h1 class="filter-button-text" [class.inactive]="filterValue.value!==3">Filter</h1>
      <img src="assets/filter.svg" />
    </button> -->
    @if(showReportType==='DISTRICTS'){
    <div class="d-flex align-items-center dp-input-control search-bar"
      style="border: 1px solid var(--bg-overlay); padding-right: 10px">
      <input type="text" [formControl]="searchTerm" placeholder="Search by displayed result" class="input-div" />
    </div>
    } @if(showReportType==='PINCODES'){
    <div class="print-monitor-button-group justify-content-between">
      <div class="d-flex" [class.flex-column]="mobileDevice" style="gap: 18px">

        <div class="d-flex flex-row" style="gap: 18px">
          <button class="dp-primary-btn" [class.inactive]="viewFilterValue.value===1" (click)="openFilterDialog()"
            [disabled]="viewFilterValue.value===1">
            <!-- <h1 class="filter-button-text" >Filter</h1> -->
            <img src="assets/filter.svg" />
          </button>
          @if(visitedFilters){
          <button type="button" class="dp-destructive-btn" style="padding: 10px 12px;"
            (click)="visitedFilters=undefined;fetchReportsForMembersClick('','','',true,true)">
            &#10006;
          </button>
          }
        </div>
        <div class="separatorDiv"></div>

        <mat-form-field class="select-mat-form-field" style="width: 15rem">
          <mat-select class="custom-mat-select" [formControl]="viewFilterValue"
            placeholder="(Select status)">@for(option of viewFilterOptions;track option){
            <mat-option (click)="onViewSelect()" [value]="option.id">
              {{ option.name }} </mat-option>}
          </mat-select>
        </mat-form-field>
        @if(viewFilterValue.value===1){
        <div class="d-flex align-items-center dp-input-control"
          style="border: 1px solid var(--bg-overlay); padding-right: 10px">
          <input type="text" [formControl]="address" placeholder="Search by address" class="input-div" />
          <img src="../../assets/images/search-white.svg" class="cursor-pointer" style="position: relative"
            (click)="fetchReportsForMembersClick('','','',true,true)" />
        </div>
        }
      </div>

      <div class="d-flex" style="gap: 10px">
        @if(showReportType==='PINCODES'){
        <!-- <button
          class="print-selected-button dp-secondary-btn"
          (click)="printAll()"
        >
          Print All
        </button> -->
        <button class="print-selected-button dp-primary-btn" (click)="printSelected()" [disabled]="!printData.length">
          Print Selected</button>}
      </div>
    </div>
    } @if(showReportType === 'COUNTRIES'){
    <div class="homeTable">
      <dp-table [dataTable]="reports" [displayedColumns]="displayHomeColumnData"
        [componentMap]="cellComponentMapAllCountry" (cellClick)="onStateClick($event)"></dp-table>
    </div>
    } @else if(showReportType === 'STATES') {
    <dp-table [dataTable]="reports" [displayedColumns]="displayStateColumnData"
      [componentMap]="cellComponentMapAllState" (cellClick)="onDistrictClick($event)"></dp-table>
    } @else { @if(showReportType === 'DISTRICTS') { @if(!mobileDevice) {
    <dp-table [dataTable]="reports" [displayedColumns]="displayColumnData" [componentMap]="cellComponentMap"
      (cellClick)="onCellClick($event)"></dp-table>
    } @else {
    <div class="tableBoxMob mt-4">
      <div class="dp-table-scroll" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
        [scrollWindow]="false">
        @for( lists of reports; track lists){
        <ul class="eachdataList">
          @if(!districtCellClicked){
          <li class="data">
            District
            <span class="clicable-text">{{ lists.district_name }}</span>
          </li>
          } @if(districtCellClicked){
          <li class="data">
            Pincode
            <span>{{ lists.pincode }}</span>
          </li>
          }
          <li class="data">
            Active<span>{{ lists.total_active_count }}</span>
          </li>
          <li class="data">
            Inactive <span>{{ lists.total_inactive_count }}</span>
          </li>

          <li class="data">
            Stagnant
            <span (click)="onCellClick(lists.pincode)" class="clicable-text">{{
              lists.total_stagnant_data
              }}</span>
          </li>
        </ul>
        }
      </div>
    </div>
    } } @else { @if(!mobileDevice){
    <div class="dp-table-scroll" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
      [scrollWindow]="false" (scrolled)="onScrollTable()">
      <dp-table [dataTable]="memberData" [displayedColumns]="displayMemberColumnData"
        [componentMap]="memberCellComponentMap" [showCheckboxes]="true" (cellClick)="onMemberCellClick($event, '')"
        (selectedRowsChange)="onCheckboxChange($event)"></dp-table><!--[columnConfs]="columnConfs"-->
    </div>
    } @else {
    <div class="tableBoxMob mt-3">
      <div class="selectAllCheck">
        <label class="custom-checkbox">
          <input [checked]="isAllChecked" type="checkbox" (change)="onAllselectCheckbox(memberData)" />
          <span class="checkmark"></span>
        </label>

        <span>Select All</span>
      </div>
      <div class="dp-table-scroll" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="1000">
        @for( lists of memberData; track lists){
        <ul class="eachdataList">
          <li class="data">
            <label class="custom-checkbox">
              <input [checked]="isAllChecked" type="checkbox" (change)="onCheckboxChange(lists)" />
              <span class="checkmark"></span>
            </label>
          </li>
          <li class="data">
            SL. NO
            <span #tooltip="matTooltip" matTooltipPosition="below" (click)="tooltip.show()" matTooltip="Sl no. copied"
              [cdkCopyToClipboard]="lists.slno" class="serial-no">{{ lists.SL_NO }}</span>
          </li>

          <li class="data">
            Name
            <span>{{ lists.dikshyarthi_name }}</span>
          </li>

          <li class="data">
            Ritwik Name<span>{{ lists.ritwiki_name }}</span>
          </li>

          <li class="data">
            Guardian Name <span>{{ lists.guardian_name }}</span>
          </li>
          <li class="data">
            Initiation Date <span>{{ lists.initiation_date }}</span>
          </li>

          <li class="data">
            Pin <span>{{lists.pin}}</span>
          </li>

          <li class="data">
            Address <span>{{ lists.permanent_address }}</span>
          </li>

          @if(lists.wishlistId !=null){
          <li class="data">
            Wishlist name
            <span>{{lists.wishlist_name}}</span>
          </li>
          }

          <li class="actions">
            <div class="d-flex align-items-center btn-gap flex-wrap">
              @if(lists.wishlistId==null){
              <button class="dp-secondary-btn btn-padding" (click)="onMemberCellClick(lists, 'like')">
                <div class="img-div" style="background: var(--heart-icon-pm);"></div>
                <span class="ms-2">Favourite</span>
              </button>
              <button class="dp-secondary-btn btn-padding" (click)="onMemberCellClick(lists, 'wishlist')">
                <div class="img-div" style="background: var(--sticky-note);"></div>
                <span class="ms-2">Wishlist</span>
                <!-- @if(lists.wishlistId != null){
                  <img src="../../assets/images/tick-gold.svg" />
                  } -->
              </button>
              }
              <!-- <button class="dp-secondary-btn btn-padding d-flex align-items-center"
                (click)="onMemberCellClick(lists, 'edit')">
                <div class="img-div" style="background: var(--edit);"></div>
                <span class="ms-2">Notes</span>
              </button> -->
              @if(lists.wishlistId !=null){
              <button class="dp-secondary-btn btn-padding" [disabled]="lists.isVisitedByMe===1"
                (click)="onMemberCellClick(lists, 'Add details')" [class.disabled]="lists.isVisitedByMe===1">
                @if(lists.isVisitedByMe===1){
                <div class="tick" style="background:var(--disc-tick)"></div>
                }
                <div class="img-div" style="background:var(--location)"></div>
              </button>
              <button class="dp-secondary-btn btn-padding" [disabled]="lists.visit_count===0"
                (click)="onMemberCellClick(lists, 'Visit history')" [class.disabled]="lists.visit_count===0">
                @if(lists.visit_count>0){
                <div class="visit-count">{{lists.visit_count}}</div>
                }
                <div class="img-div" style="background:var(--visit-history)"></div>
              </button>
              }
            </div>
          </li>
        </ul>
        }
      </div>
    </div>
    } } }
  </div>
</div>